import VueRouter from "vue-router";
import store from '@/store'

import Home from "./views/home.vue";
import changePassword from "./views/changePassword.vue";
import Login from "./views/auth/login.vue";
import PageNotFound from "./views/notFound.vue";
import PageDeniedAccess from "./views/unauthorized.vue";
import RecoveryPage from "./views/recoveryByMail.vue";
import Profil from "./views/user/profile.vue";
import Report from "./views/report.vue";
import ReportShow from "./views/reportshow.vue";
// * User

import UserCreate from "./views/user/create.vue"
import UserIndex from "./views/user/index.vue"
import UserIndexClient from "./views/user/client.vue"
import UserShow from "./views/user/show.vue"
import UserSearch from "./views/user/search.vue"
import UserEdit from "./views/user/edit.vue"

// * Ticket 


import EntrepriseCreate from "./views/entreprise/create.vue"
import EntrepriseIndex from "./views/entreprise/index.vue"
import EntrepriseEdit from "./views/entreprise/edit.vue"
import EntrepriseShow from "./views/entreprise/show.vue"


const routes = [{
        path: "/",
        name: "home",
        component: Home,
        meta: {
            layout: "Default",
            requiredAuth: true,
            perm: null
        }
    },
    {
        path: "/password/:token/:email",
        name: "changePassword",
        component: changePassword,
        meta: {
            layout: "Auth",
            requiredAuth: false,
            perm: null
        }
    },
    {
        path: "/recovery",
        name: "recovery",
        component: RecoveryPage,
        meta: {
            layout: "Auth",
            requiredAuth: false,
            perm: null
        }
    },
    {
        path: "/report",
        name: "Report",
        component: Report,
        meta: {
            layout: "Default",
            perm: 'index-users'
        }
    },
    {
        path: "/show-report/:id",
        name: "ReportShow",
        component: ReportShow,
        meta: {
            layout: "Default",
            perm: 'index-users'
        }
    },

    {
        path: "*",
        component: PageNotFound,
        meta: {
            layout: "Auth",

        }

    },
    {
        path: "/denied",
        component: PageDeniedAccess,
        meta: {
            layout: "Auth",

        }

    },

    {
        path: "/connexion",
        name: "connexion",
        component: Login,
        meta: {
            layout: "Auth",

        }
    },

    {
        path: "/profil",
        name: "profil",
        component: Profil,
        meta: {
            layout: "Default",

        }
    },



    //  

    // * USER
    {
        path: "/create-user",
        name: "UserCreate",
        component: UserCreate,
        meta: {
            layout: "Default",
            perm: 'create-users'
        }
    },
    {
        path: "/index-users",
        name: "UserIndex",
        component: UserIndex,
        meta: {
            layout: "Default",
            perm: 'index-users'
        }
    },
    {
        path: "/index-client",
        name: "UserIndexClient",
        component: UserIndexClient,
        meta: {
            layout: "Default",
            perm: 'index-users'
        }
    },
    {
        path: "/show-user/:id",
        name: "UserShow",
        component: UserShow,
        meta: {
            layout: "Default",
            perm: 'show-users'
        }
    },
    {
        path: "/search-user",
        name: "UserSearch",
        component: UserSearch,
        meta: {
            layout: "Default",
            //perm: 'show-users'
        }
    },
    {
        path: "/edit-user/:id",
        name: "Edit",
        component: UserEdit,
        meta: {
            layout: "Default",
            perm: 'edit-users'
        }
    },

    // *  Type repas
    {
        path: "/create-entreprise",
        name: "EntrepriseCreate",
        component: EntrepriseCreate,
        meta: {
            layout: "Default",
            perm: 'create-meal-types'
        }
    },
    {
        path: "/edit-entreprise/:id",
        name: "EntrepriseEdit",
        component: EntrepriseEdit,
        meta: {
            layout: "Default",
            perm: 'edit-meal-types'
        }
    },
    {
        path: "/show-entreprise/:id",
        name: "EntrepriseShow",
        component: EntrepriseShow,
        meta: {
            layout: "Default",
            perm: 'show-meal-types'
        }
    },
    {
        path: "/index-entreprises",
        name: "EntrepriseIndex",
        component: EntrepriseIndex,
        meta: {
            layout: "Default",
            perm: 'index-meal-types'
        }
    },







];



const router = new VueRouter({
    history: true,
    mode: "history",
    routes,
});

// var perms = store.state.perms.split('911');

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiredAuth)) {
        console.log('required')
        if (store.state.token) {
            if (to.meta.perm) {
                next()
            } else {
                next()
            }
        } else {
            next("/connexion")
        }
    } else {
        console.log('non required')
        if (to.meta.perm) {
            /* if (perms.includes(to.meta.perm)) {
              next()
            } else {
              next("/denied")
            } */
            next()
        } else {
            next()
        }
    }
})

export default router;